import {
  ON_START_UPDATE_ARTIKEL_FORTNOX,ARTREG_ON_UPDATE_ARTIKEL_FORTNOX,ARTREG_ERROR_ON_UPDATE_ARTIKEL_FORTNOX,
  ON_START_ADD_NEW_FREEINPUT_ARTIKEL,ON_ADD_NEW_FREEINPUT_ARTIKEL,ON_ERROR_ADD_NEW_FREEINPUT_ARTIKEL,
  ON_START_ARTIKEL_CLOSE_TOASTR,ON_START_GET_THIS_FREEINPUT_ARTIKEL,ON_GET_THIS_FREEINPUT_ARTIKEL,
  ON_START_DETELE_THIS_ARTICLE_FREEINPUT,ON_DETELE_THIS_ARTICLE_FREEINPUT,ON_ERROR_DETELE_THIS_ARTICLE_FREEINPUT,
  ON_START_UPDATE_FREEINPUT_ARTIKEL,ON_UPDATE_FREEINPUT_ARTIKEL,ON_ERROR_UPDATE_FREEINPUT_ARTIKEL,
  ON_START_GET_THIS_FREEINPUTS_ARTIKEL,ON_GET_THIS_FREEINPUTS_ARTIKEL,
  ON_SET_ARTIKLAR_TAB_INDEX,
  ON_START_GET_ARTEKLAR_EXCEL,ON_GET_ARTEKLAR_EXCEL,ON_ERROR_GET_ARTEKLAR_EXCEL,
  ON_START_IMPORT_ARTIKLAR_FUNC,ON_IMPORT_ARTIKLAR_FUNC,ON_ERROR_IMPORT_ARTIKLAR_FUNC,
  ON_START_Delete_SHARED_OFFICE,ON_Delete_SHARED_OFFIC,ON_ERROR_Delete_SHARED_OFFIC,
  
  UNSET_ARTIKLARVY_TYPE,
  ARTREG_ON_START_ADD_ARTIKEL,
  ARTREG_ON_ERROR_ADD_ARTIKEL,
  ARTREG_ON_ADD_ARTIKEL,
  ON_GET_FREEINPUT_ARTIKEL,ON_START_GET_FREEINPUT_ARTIKEL,

  ARTREG_ON_START_GET_ARTIKEL_NR,
  ARTREG_ON_ERROR_GET_ARTIKEL_NR,
  ARTREG_ON_GET_ARTIKEL_NR,

  ARTREG_ON_DELETE_ARTIKEL,
  ARTREG_ON_GET_ARTIKEL,
  ARTREG_ON_GET_ARTIKLAR,
  ARTREG_ON_EMPTY_ARTIKLAR,
  ARTREG_ON_START_GET_ARTIKLAR,
  ARTREG_ON_ERROR_GET_ARTIKLAR,
  ARTREG_ON_GET_ARTIKEL_COUNT,

  
  ARTREG_START_GET_PRICELISTS,
  ARTREG_ERROR_GET_PRICELISTS,
  ARTREG_ON_GET_PRICELISTS,
  ARTREG_ON_DELETE_PRICELIST,
  ARTREG_ON_ADD_PRICELIST,

  ARTREG_ON_START_UPDATE_ARTIKEL,
  ARTREG_ON_ERROR_UPDATE_ARTIKEL,
  ARTREG_ON_UPDATE_ARTIKEL,
  ARTREG_ON_UPDATE_ARTIKEL_MULTI,
  ARTREG_ON_START_UPDATE_ARTIKEL_MULTI,
  ARTREG_ON_ERROR_UPDATE_ARTIKEL_MULTI,

  ARTREG_ON_RESPOSE,
  ARTREG_ON_RESPOSE_RESET,
  ARTREG_ON_SEARCH_ARTIKLAR,
  ARTREG_ON_START_SEARCH_ARTIKLAR,
  ARTREG_ON_ERROR_SEARCH_ARTIKLAR,
  ARTREG_ON_GET_ARTIKEL_TAGS,
  ARTREG_ON_GET_ARTIKEL_SUB,

  ON_OPEN_FILTER_ARTIKLAR,
  ON_ClOSE_FILTER_ARTIKLAR,
  SET_ARTIKLAR_FILTER,
  ON_START_CREATE_WOOCOMMERCE_PRODUCT,
  ON_CREATE_WOOCOMMERCE_PRODUCT,
  ON_ERROR_CREATE_WOOCOMMERCE_PRODUCT,
  ON_START_CONNECT_WOOCOMMERCE_PRODUCT,
  ON_CONNECT_WOOCOMMERCE_PRODUCT,
  ON_ERROR_CONNECT_WOOCOMMERCE_PRODUCT,
  ON_START_DISCONNECT_WOOCOMMERCE_PRODUCT,
  ON_DISCONNECT_WOOCOMMERCE_PRODUCT,
  ON_ERROR_DISCONNECT_WOOCOMMERCE_PRODUCT,
  ON_GET_ARTIKLAR_PAGE_BASIC,
  
  ON_UPDATE_WHOLESALESUTIE_PRODUCT_DATA,
  ON_START_UPDATE_WHOLESALESUTIE_PRODUCT_DATA,
  ON_ERROR_UPDATE_WHOLESALESUTIE_PRODUCT_DATA,
  
}  from '../constants/ActionTypes'

import {isUndefined} from 'lodash'
import { translate } from "../util/intlHelper";

const INIT_STATE = {  
  Artiklar: [],
  currentArt: {},
  currentList: [],
  currentListCount: 0,
  currentListLoading: false,
  count: 0,
  response: {},
  loading: false,
  loadingNewArtNr: false,
  newArtNr: 0,
  currTabIndex:1,
  ArtikelTagsList: [],
  ArtikelSubList: [],
  ArtikelSubListCount:0,
  SearchingArtikel: false,
  FilterArtiklarPopup: false,
  ArtiklarFilterOption: isUndefined(localStorage.ArtiklarFilter)?[]:JSON.parse(localStorage.ArtiklarFilter),
  PageSize:25,
  Searchtext: "",
  Page: 1,
  JKmessage:{},
  startprogress:false,
  artikelFreeInputs:[],
  artikelFreeInput:[],
  KalkylartikelFreeInputs:[],
  ResponseMsg:{}
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ON_UPDATE_WHOLESALESUTIE_PRODUCT_DATA: {
      console.log("ON_UPDATE_WHOLESALESUTIE_PRODUCT_DATA", action.payload)
      return {
        ...state,
        loading: false,
        response: {
          type: 'success',
          success: false,
          show: true,
          msg: translate('Action.Save.list'),
          func: 'update'
        }
      }
    }
    case ON_START_UPDATE_WHOLESALESUTIE_PRODUCT_DATA: {
      console.log("ON_START_UPDATE_WHOLESALESUTIE_PRODUCT_DATA", action.payload)
      return {
        ...state,
        loading: true,
        response: {
          type: 'info',
          success: true,
          loading: true,
          show: true,
          msg: translate("Action.Saving.list"),
          func: 'update'
        }
      }
    }
    case ON_ERROR_UPDATE_WHOLESALESUTIE_PRODUCT_DATA: {
      console.log("ON_ERROR_UPDATE_WHOLESALESUTIE_PRODUCT_DATA", action.payload)
      return {
        ...state,
        loading: false,
        response: {
          type: 'error',
          success: false,
          show: true,
          msg: translate("Action.Saving.list.Error"),
          func: 'update'
        }
      }
    }
    case ARTREG_ON_START_ADD_ARTIKEL:{
      console.log('ARTREG_ON_START_ADD_ARTIKEL', action)
      return { 
        ...state,
        loading: true,
        response: {}
      };
    }
    case ARTREG_ON_ERROR_ADD_ARTIKEL:{
      console.log('ARTREG_ON_ERROR_ADD_ARTIKEL', action)
      return { 
        ...state,
        loading: false,
        response: {
          type: translate("Action.Adding.Item.Error"),
          success: false,
          show: true,
          msg: action.payload,
          func: 'add'
        }
      };
    }
    case ARTREG_ON_ADD_ARTIKEL:{
      console.log('ARTREG_ON_ADD_ARTIKEL', action)
      return { 
        ...state,
        loading: false,
        response: {
          type: 'success',
          success: false,
          show: true,
          msg: translate("Action.Add.Item"),
          func: 'add'
        }
      };
    }
    case ARTREG_ON_START_UPDATE_ARTIKEL:{
      console.log('ARTREG_ON_START_UPDATE_ARTIKEL', action)
      return { 
        ...state,
        loading: true,
        response: {}
      };
    }
    case ARTREG_ON_ERROR_UPDATE_ARTIKEL:{
      console.log('ARTREG_ON_ERROR_UPDATE_ARTIKEL', action)
      return { 
        ...state,
        loading: false,
        response: {
          type: 'error',
          success: false,
          show: true,
          msg: action.payload,
          func: 'update'
        }
      };
    }
    case ARTREG_ON_UPDATE_ARTIKEL:{
      console.log('ARTREG_ON_UPDATE_ARTIKEL', action)
      return { 
        ...state,
        loading: false,
        response: {
          type: 'success',
          success: true,
          show: true,
          msg: translate("Action.Save.Item"),
          func: 'update'
        }
      };
    }
    case ARTREG_ON_START_UPDATE_ARTIKEL_MULTI:{
      console.log('ARTREG_ON_START_UPDATE_ARTIKEL_MULTI', action)
      return { 
        ...state,
        loading: true,
        response:  {
          type: 'info',
          success: false,
          show: true,
          msg: translate("Action.saveing.prices"),
          func: 'update',
          loading: true
        }
      };
    }
    case ARTREG_ON_ERROR_UPDATE_ARTIKEL_MULTI:{
      console.log('ARTREG_ON_ERROR_UPDATE_ARTIKEL_MULTI', action)
      return { 
        ...state,
        loading: false,
        response: {
          type: 'error',
          success: false,
          show: true,
          msg: action.payload,
          func: 'update'
        }
      };
    }
    case ARTREG_ON_UPDATE_ARTIKEL_MULTI:{
      console.log('ARTREG_ON_UPDATE_ARTIKEL_MULTI', action)
      return { 
        ...state,
        loading: false,
        response: {
          type: 'success',
          success: true,
          show: true,
          msg: translate("Action.items.saved"),
          func: 'update'
        }
      };
    }
    case ARTREG_ON_START_GET_ARTIKEL_NR:{
      console.log('ARTREG_ON_START_GET_ARTIKEL_NR', action)
      return { 
        ...state,
        loadingNewArtNr: true,
        response: {},
        newArtNr: 0,
      };
    }
    case ARTREG_ON_ERROR_GET_ARTIKEL_NR:{
      console.log('ARTREG_ON_ERROR_GET_ARTIKEL_NR', action)
      return { 
        ...state,
        loadingNewArtNr: false,
        newArtNr: 0,
        response: {
          type: 'error',
          success: false,
          show: true,
          msg: action.payload,
          func: 'getnr'
        }
      };
    }
    case ARTREG_ON_GET_ARTIKEL_NR:{
      console.log('ARTREG_ON_GET_ARTIKEL_NR', action)
      return { 
        ...state,
        loadingNewArtNr: false,
        newArtNr: action.payload,
        response: {
          type: 'success',
          success: true,
          show: true,
          msg: translate("Action.item.fetch.new.Nr"),
          func: 'getnr'
        }
      };
    }
    case ARTREG_ON_DELETE_ARTIKEL:{
      console.log('ARTREG_ON_DELETE_ARTIKEL', action)
      return { ...state};
    }
    case ARTREG_ON_GET_ARTIKEL:{
      console.log('ARTREG_ON_GET_ARTIKEL', action)
      return { ...state, currentArt: action.payload};
    }
    
    case ARTREG_ON_EMPTY_ARTIKLAR:{
      console.log('ARTREG_ON_EMPTY_ARTIKLAR', action)
      return { ...state,  Artiklar: [], count: 0 };
    }
    case ARTREG_ON_START_GET_ARTIKLAR : {
      console.log('ARTREG_ON_START_GET_ARTIKLAR', action)
      return { ...state, loading: true};
    }
    case ARTREG_ON_ERROR_GET_ARTIKLAR : {
      console.log('ARTREG_ON_ERROR_GET_ARTIKLAR', action)
      return { ...state, loading: false, Artiklar: [] };
    }

    case ARTREG_ON_GET_ARTIKLAR:{
      console.log('ARTREG_ON_GET_ARTIKLAR', action)
      console.log(action.payload)
      return { ...state, 
        loading: false, 
        Artiklar: action.payload.Artiklar, 
        PageSize: action.payload.PageSize,
        Page: action.payload.Page,
        Searchtext: action.payload.Searchtext,
      };
    }
    
    case ARTREG_ON_GET_ARTIKEL_COUNT:{
      console.log('ARTREG_ON_GET_ARTIKEL_COUNT', action)
      // console.log(action.payload[0]["COUNT(*)"])
      return { ...state, count: action.payload[0]["COUNT(*)"]};
    }
    case ARTREG_ON_START_SEARCH_ARTIKLAR:{
      console.log('ARTREG_ON_START_SEARCH_ARTIKLAR', action)
      return { ...state, Artiklar: [], count: 0, SearchingArtikel: true, loading: true};
    }
    case ARTREG_ON_SEARCH_ARTIKLAR:{
      console.log('ARTREG_ON_SEARCH_ARTIKLAR', action)
      return { ...state, 
        Artiklar: action.payload.Artiklar, 
        count: action.payload.Count, 
        SearchingArtikel: false, 
        PageSize: action.payload.PageSize, 
        Page: action.payload.Page,
        Searchtext: action.payload.Searchtext,
        loading: false
        
      };
    }
    case ARTREG_ON_ERROR_SEARCH_ARTIKLAR:{
      console.log('ARTREG_ON_ERROR_SEARCH_ARTIKLAR', action)
      return { ...state, Artiklar: [], count: 0, SearchingArtikel: false,  loading: false};
    }

    
    case ARTREG_ON_GET_PRICELISTS:{
      console.log('ARTREG_ON_GET_PRICELISTS', action)
      return { 
        ...state, 
        currentListLoading: false,
        currentList: action.payload.prislistor, 
        currentListCount:  action.payload.count
      };
    }
    
    case ARTREG_START_GET_PRICELISTS: {
      console.log("ARTREG_START_GET_PRICELISTS", action.payload)
      return {
        ...state,
        currentListLoading: true,
        currentList: [],
        currentListCount: []
      }
    }
    case ARTREG_ERROR_GET_PRICELISTS: {
      console.log("ARTREG_ERROR_GET_PRICELISTS", action.payload)
      return {
        ...state,
        currentListLoading: false
      }
    }

    case ARTREG_ON_DELETE_PRICELIST:{
      console.log('ARTREG_ON_DELETE_PRICELIST', action)
      return { ...state};
    }
    case ARTREG_ON_ADD_PRICELIST:{
      console.log('ARTREG_ON_ADD_PRICELIST', action)
      return { ...state};
    }


    case ARTREG_ON_RESPOSE:{
      console.log('ARTREG_ON_RESPOSE', action)
      return { ...state, response: action.payload};
    }
    case ARTREG_ON_RESPOSE_RESET:{
      console.log('ARTREG_ON_RESPOSE_RESET', action)
      return { ...state, response: {...state.response, show: false}};
    }
    case ARTREG_ON_GET_ARTIKEL_TAGS: {
      console.log('ARTREG_ON_GET_ARTIKEL_TAGS', action)
      return {...state, ArtikelTagsList: action.payload}
    }
    case ARTREG_ON_GET_ARTIKEL_SUB: {
      console.log('ARTREG_ON_GET_ARTIKEL_SUB', action)
      return {...state, 
        ArtikelSubList: action.payload.subArt,
        ArtikelSubListCount: action.payload.subArtCount
       }
    }

    case ON_OPEN_FILTER_ARTIKLAR: {
      console.log("ON_OPEN_FILTER_ARTIKLAR", action.payload)
      return {
        ...state, 
        FilterArtiklarPopup:true,
        
        ArtiklarFilterOption:isUndefined(localStorage.ArtiklarFilter)?[]:JSON.parse(localStorage.ArtiklarFilter)
      }
    }
    case ON_ClOSE_FILTER_ARTIKLAR: {
      console.log("ON_ClOSE_FILTER_ARTIKLAR", action.payload)
      return {...state, FilterArtiklarPopup:false}
    }
    case SET_ARTIKLAR_FILTER: {
      console.log("SET_ARTIKLAR_FILTER", action.payload)
      localStorage.removeItem("ArtiklarFilter");
      localStorage.setItem("ArtiklarFilter", JSON.stringify(action.payload));
      return {...state, ArtiklarFilterOption: action.payload}
    }

    case ON_START_CONNECT_WOOCOMMERCE_PRODUCT: {
      console.log("ON_START_CONNECT_WOOCOMMERCE_PRODUCT",action.payload)

      return {
        ...state
      }
    }
    case ON_CONNECT_WOOCOMMERCE_PRODUCT: {
      console.log("ON_CONNECT_WOOCOMMERCE_PRODUCT",action.payload)

      return {
        ...state,
        currentArt: action.payload.Artikel,
        response: {
          type: 'success',
          show: true,
          msg: translate("Action.connected.item")
        }
      }
    }
    case ON_ERROR_CONNECT_WOOCOMMERCE_PRODUCT: {
      console.log("ON_ERROR_CONNECT_WOOCOMMERCE_PRODUCT",action.payload)

      return {
        ...state,
        response: {
          type: 'error',
          show: true,
          msg: action.payload
        }
      }
    }
    
    case ON_START_DISCONNECT_WOOCOMMERCE_PRODUCT:{
      console.log("ON_START_DISCONNECT_WOOCOMMERCE_PRODUCT",action.payload)
      return {
        ...state
      }
    }
    case ON_DISCONNECT_WOOCOMMERCE_PRODUCT:{
      console.log("ON_DISCONNECT_WOOCOMMERCE_PRODUCT",action.payload)
      return {
        ...state,
        currentArt: action.payload.Artikel,
        response: {
          type: 'warning',
          show: true,
          msg: translate("Action.remove.connected.item")
        }
      }
    }
    case ON_ERROR_DISCONNECT_WOOCOMMERCE_PRODUCT:{
      console.log("ON_ERROR_DISCONNECT_WOOCOMMERCE_PRODUCT",action.payload)
      return {
        ...state,
        response: {
          type: 'error',
          show: true,
          msg: action.payload
        }
      }
    }

    case ON_START_CREATE_WOOCOMMERCE_PRODUCT:{
      console.log("ON_START_CREATE_WOOCOMMERCE_PRODUCT",action.payload)
      return {
        ...state
      }
    }
    case ON_CREATE_WOOCOMMERCE_PRODUCT:{
      console.log("ON_CREATE_WOOCOMMERCE_PRODUCT",action.payload)
      return {
        ...state,
        currentArt: action.payload.Artikel,
        response: {
          type: 'success',
          show: true,
          msg: translate("Action.Create.item.Woocommerce")
        }
      }
    }
    case ON_ERROR_CREATE_WOOCOMMERCE_PRODUCT:{
      console.log("ON_ERROR_CREATE_WOOCOMMERCE_PRODUCT",action.payload)
      return {
        ...state,
        response: {
          type: 'error',
          show: true,
          msg: action.payload
        }
      }
    }
//ON_START_UPDATE_ARTIKEL_FORTNOX,ARTREG_ON_UPDATE_ARTIKEL_FORTNOX,ARTREG_ERROR_ON_UPDATE_ARTIKEL_FORTNOX,
case ON_START_UPDATE_ARTIKEL_FORTNOX:{
  console.log("ON_START_UPDATE_ARTIKEL_FORTNOX",action.payload)
  return {
    ...state,
    JKmessage:action.payload.message,
    startprogress:true
  }
}
case ARTREG_ON_UPDATE_ARTIKEL_FORTNOX:{
  console.log("ARTREG_ON_UPDATE_ARTIKEL_FORTNOX",action.payload)
  return {
    ...state,
    startprogress:false,
    response: {
      type: 'success',
      show: true,
      msg: action.payload.results.message
    }
  }
}
case ARTREG_ERROR_ON_UPDATE_ARTIKEL_FORTNOX:{
  console.log("ARTREG_ERROR_ON_UPDATE_ARTIKEL_FORTNOX",action.payload)
  return {
    ...state,
    JKmessage:action.payload,
    startprogress:true
  }
}
//ON_START_ADD_NEW_FREEINPUT_ARTIKEL,ON_ADD_NEW_FREEINPUT_ARTIKEL,ON_ERROR_ADD_NEW_FREEINPUT_ARTIKEL,
case ON_START_ADD_NEW_FREEINPUT_ARTIKEL: {
  return {...state,
    ResponseMsg:{msg:translate("Action.item.Creating.FreeFields"),type:"info",loading:true},
  }
}
case ON_ADD_NEW_FREEINPUT_ARTIKEL: {
  return {...state,
    ResponseMsg:{msg:action.payload.message,type:"success",loading:false},
    artikelFreeInputs:action.payload.artikelFreeInputs
  }
}
case ON_ERROR_ADD_NEW_FREEINPUT_ARTIKEL: {
  return {...state,
    ResponseMsg:{msg:action.payload,type:"error",loading:false},
  }
}
//ON_START_ARTIKEL_CLOSE_TOASTR
case ON_START_ARTIKEL_CLOSE_TOASTR: {
  return {...state,
    ResponseMsg:{},
  }
}
//ON_START_GET_FREEINPUT_ARTIKEL
case ON_START_GET_FREEINPUT_ARTIKEL: {
  return {...state,
    artikelFreeInputs:[]
  }
}
//ON_GET_FREEINPUT_ARTIKEL
case ON_GET_FREEINPUT_ARTIKEL: {
  console.log("ON_GET_FREEINPUT_ARTIKEL",action)
  return {...state,
    artikelFreeInputs:action.payload.artikelFreeInputs
  }
}
//ON_START_GET_THIS_FREEINPUT_ARTIKEL,ON_GET_THIS_FREEINPUT_ARTIKEL,
case ON_START_GET_THIS_FREEINPUT_ARTIKEL: {
  return {...state,
    artikelFreeInput:[]
  }
}
//ON_GET_FREEINPUT_ARTIKEL
case ON_GET_THIS_FREEINPUT_ARTIKEL: {
  console.log("ON_GET_THIS_FREEINPUT_ARTIKEL",action)
  return {...state,
    artikelFreeInput:action.payload.artikelFreeInput
  }
}
//ON_START_DETELE_THIS_ARTICLE_FREEINPUT,ON_DETELE_THIS_ARTICLE_FREEINPUT,ON_ERROR_DETELE_THIS_ARTICLE_FREEINPUT,
case ON_START_DETELE_THIS_ARTICLE_FREEINPUT: {
  return {...state,
    ResponseMsg:{msg:translate("Action.item.deleting.FreeFields"),type:"info",loading:true},
  }
}
case ON_DETELE_THIS_ARTICLE_FREEINPUT: {
  return {...state,
    ResponseMsg:{msg:action.payload.message,type:"warning",loading:false},
    artikelFreeInputs:{},
    artikelFreeInputs:action.payload.artikelFreeInputs
  }
}
case ON_ERROR_DETELE_THIS_ARTICLE_FREEINPUT: {
  return {...state,
    ResponseMsg:{msg:action.payload,type:"error",loading:false},
  }
}
//ON_START_UPDATE_FREEINPUT_ARTIKEL,ON_UPDATE_FREEINPUT_ARTIKEL,ON_ERROR_UPDATE_FREEINPUT_ARTIKEL,
case ON_START_UPDATE_FREEINPUT_ARTIKEL: {
  return {...state,
    ResponseMsg:{msg:translate("Action.item.Saving.FreeFields"),type:"info",loading:true},
  }
}
case ON_UPDATE_FREEINPUT_ARTIKEL: {
  return {...state,
    ResponseMsg:{msg:action.payload.message,type:"success",loading:false},
    artikelFreeInputs:{},
    artikelFreeInputs:action.payload.artikelFreeInputs
  }
}
case ON_ERROR_UPDATE_FREEINPUT_ARTIKEL: {
  return {...state,
    ResponseMsg:{msg:action.payload,type:"error",loading:false},
  }
}
//
case ON_START_UPDATE_FREEINPUT_ARTIKEL: {
  return {...state }
}
case ON_GET_THIS_FREEINPUTS_ARTIKEL: {
  return {...state,
    KalkylartikelFreeInputs:action.payload.KalkylartikelFreeInputs
  }
}
//ON_START_GET_ARTEKLAR_EXCEL,ON_GET_ARTEKLAR_EXCEL,ON_ERROR_GET_ARTEKLAR_EXCEL
case ON_START_GET_ARTEKLAR_EXCEL: {
  return {...state,
    ResponseMsg:{msg:translate("Action.Exporting.items"),type:"info",loading:true},
  }
}
case ON_GET_ARTEKLAR_EXCEL: {
  return {...state,
    ResponseMsg:{msg:translate("Action.Export.items"),type:"success",loading:false},
  }
}
case ON_ERROR_GET_ARTEKLAR_EXCEL: {
  return {...state,
    ResponseMsg:{msg:action.payload,type:"error",loading:false},
  }
}
//ON_START_IMPORT_ARTIKLAR_FUNC,ON_IMPORT_ARTIKLAR_FUNC,ON_ERROR_IMPORT_ARTIKLAR_FUNC,
case ON_START_IMPORT_ARTIKLAR_FUNC: {
  return {...state,
    ResponseMsg:{msg:translate("Action.Importing.items"),type:"info",loading:true},
  }
}
case ON_IMPORT_ARTIKLAR_FUNC: {
  return {...state,
    ResponseMsg:{msg:translate("Action.Import.items"),type:"success",loading:false},
  }
}
case ON_ERROR_IMPORT_ARTIKLAR_FUNC: {
  return {...state,
    ResponseMsg:{msg:action.payload,type:"error",loading:false},
  }
}
case ON_SET_ARTIKLAR_TAB_INDEX: {
  console.log(action.payload,"DADADAD")
  return {...state,
    currTabIndex:action.payload.TabIndex
  }
}
//ON_GET_ARTIKLAR_PAGE_BASIC
case ON_GET_ARTIKLAR_PAGE_BASIC: {
  console.log(action.payload,"DADADAD")
  return {...state,
    Page:action.payload.Page
  }
}
//ON_START_Delete_SHARED_OFFICE,ON_Delete_SHARED_OFFIC,ON_ERROR_Delete_SHARED_OFFIC,
case ON_START_Delete_SHARED_OFFICE: {
  return {...state,
    ResponseMsg:{},
  }
}
case ON_Delete_SHARED_OFFIC:{
  console.log('ON_Delete_SHARED_OFFIC', action)
  return { ...state, currentArt: {
    ...state.currentArt,
    Office:action.payload.Office
  }};
}
case ON_ERROR_Delete_SHARED_OFFIC: {
  return {...state,
    ResponseMsg:{msg:action.payload,type:"error",loading:false},
  }
}
//UNSET_ARTIKLARVY_TYPE
case UNSET_ARTIKLARVY_TYPE:{
  return {
    Artiklar: [],
    currentArt: {},
    currentList: [],
    currentListCount: 0,
    count: 0,
    response: {},
    loading: false,
    newArtNr: 0,
    currTabIndex:1,
    ArtikelTagsList: [],
    ArtikelSubList: [],
    ArtikelSubListCount:0,
    SearchingArtikel: false,
    FilterArtiklarPopup: false,
    ArtiklarFilterOption:[],
    PageSize:25,
    Searchtext: "",
    Page: 1,
    JKmessage:{},
    startprogress:false,
    artikelFreeInputs:[],
    artikelFreeInput:[],
    KalkylartikelFreeInputs:[],
    ResponseMsg:{}
  }
}
    default: {
      return state
    }
  }
}